<template>
    <div name="questionnaire" class="questionnaire">
        <img class="image" src="../../assets/showcase/xi/detail/common/medication/1.png" @click="goHistory"/>
        <img v-if="hospital === 0" class="image" src="../../assets/showcase/xi/detail/common/medication/2_1.png" />
        <img v-else class="image" src="../../assets/showcase/xi/detail/common/medication/2_2.png" />      
        <div class="wrapper">
            <img class="image" src="../../assets/showcase/xi/detail/common/questionnaire/3.png" />
            <div class="button1" @click="goDetail">
            
            </div>
            <div class="button2" >
        
            </div>
            <div class="button3" @click="goMedicine">
        
            </div>
            <!-- <div class="button4" @click="goMedicine">

            </div> -->
        </div>
        <img class="image" src="../../assets/showcase/xi/detail/common/questionnaire/4.png" style="margin-top: -6px;"/>
    </div>
</template>

<script>
export default {
    name: 'questionnaire',
    props: ['hospital'],
    data: function()
    {
        return {
            
        }
    },
    methods: {
        goDetail: function()
        {
            this.$emit('goDetailTab');
        },
        goDelivery: function()
        {
            this.$emit('goDeliveryTab');
        },
        goMedicine: function()
        {
            this.$emit('goMedicineTab');
        },
        goHistory: function()
        {
            this.$emit('goHistory')
        }
    }
}
</script>

<style scoped>
    .questionnaire {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        background: #FFF;
    }
    .image {
        width: 100%;
    }
    .wrapper {
        position: relative;
        width: 100%;
    }
 .button1 {
        position: absolute;
        width: 20%;
        aspect-ratio: 2/1.2;
        top: 0;
        left: 0;
        z-index: 1;
    }
     .button2 {
        position: absolute;
        width: 18%;
        aspect-ratio: 2/1.3;
        top: 0;
        left: 20%;
        z-index: 1;
    }
     .button3 {
        position: absolute;
        width: 15%;
        aspect-ratio: 2/1.6;
        top: 0;
        left: 38%;
        z-index: 1;
    }
     .button4 {
        position: absolute;
        width: 21%;
        aspect-ratio: 2/1.1;
        top: 0;
        left: 53%;
        z-index: 1;
    }
</style>


// WEBPACK FOOTER //
// src/components/showcase/Questionnaire.vue